import { pages } from '../nav-items';

export const WAREHOUSE_SETTINGS_URL = `/${pages.settings.location}/${pages.warehouses.location}`;
export const EMAIL_REQUIRED_CARRIERS = ['111', '147', '2671'];
